module.exports = __webpack_public_path__ + "img/huizhang.f3e797a0.png";